<template>
  <div class='transmit-warp'>
    <div class="transmit">
      <div class="YTitle">抄送角色选择</div>

      <div class="From">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="角色名称：">
            <el-input v-model.trim="formInline.pageName" placeholder="请输入模板名称"></el-input>
          </el-form-item>
          <el-form-item class="YButtonRight">
            <el-button @click="onSubmit" plain round>重置</el-button>
            <el-button type="primary" @click="reset" round>查询</el-button>
          </el-form-item>
        </el-form>
      </div>

      <div class="table YTable">
        <el-table
          :data="TableData"
          ref="singleTable"
          @selection-change="handleSelectionChange"
          border
          height='100%'
          style="width: 100%">
          <el-table-column
            type="selection"
            align='center'>
          </el-table-column>
          <el-table-column
            v-for="(item, index) in TableHead"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            show-overflow-tooltip
            align='center'>
          </el-table-column>
        </el-table>
      </div>

      <YPagination
        :pageNum='pageNum'
        :pageSize='pageSize'
        :Total='Total'
        @SizeChange='SizeChange'
        @CurrentChange='CurrentChange'>
      </YPagination>

      <div class="btn">
        <el-button type="primary" round @click="save">选择</el-button>
        <el-button plain round @click="close">取消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/shared/api/apps/work-order'
export default {
  name: 'workOrder',

  props: {
    data: {
      type: Array,
      default () {
        return []
      }
    }
  },

  data () {
    return {
      value: [],
      pageNum: 1,
      pageSize: 10,
      dataValue: {},
      Total: 0,
      formInline: {
        pageName: ''
      },
      TableHead: [
        {
          prop: 'id',
          label: 'id'
        },
        {
          prop: 'name',
          label: '角色名称'
        },
        {
          prop: 'orgName',
          label: '所属商场'
        },
        {
          prop: 'type.name',
          label: '角色类型'
        }
      ],
      TableData: []
    }
  },

  mounted () {
    this.init()
  },

  methods: {
    init () {
      this.getTreeList()
    },

    getTreeList () {
      const params = {
        method: api.organizationTree,
        type: 0
      }

      this.axios.post(params).then(res => {
        if (res.data.backend_org_ums_organizationTree_list_response.code !== '10000') return
        if (res.data.backend_org_ums_organizationTree_list_response.items.length > 0) {
          this.dataValue = res.data.backend_org_ums_organizationTree_list_response.items[0]
          this.getData()
        }
      })
    },

    getData () {
      if (!this.dataValue.id) return
      const params = {
        method: api.getRoleListByOrgId,
        orgId: this.dataValue.id,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        type: 0,
        searchContent: this.formInline.pageName
      }
      this.axios.post(params).then(res => {
        if (res.data.backend_org_ums_role_getRoleListByOrgId_response.code !== '10000') return
        this.TableData = res.data.backend_org_ums_role_getRoleListByOrgId_response.records
        this.TableData.forEach(res => {
          res.copyObjId = res.id
          res.copyObjName = res.name
          res.copyObjType = 1
        })
        this.Total = parseInt(res.data.backend_org_ums_role_getRoleListByOrgId_response.total)
        if (this.data.length === 0) return
        const arr = []
        this.data.forEach(res => {
          arr.push(res.copyObjId)
        })
        this.TableData.forEach(res => {
          if (arr.indexOf(res.copyObjId) !== -1) {
            setTimeout(() => {
              this.$refs.singleTable.toggleRowSelection(res)
            })
          }
        })
      })
    },

    SizeChange (val) {
      this.pageSize = val
      this.pageNum = 1
      this.getData()
    },

    CurrentChange (val) {
      this.pageNum = val
      this.getData()
    },

    onSubmit () {
      this.pageNum = 1
      this.formInline.pageName = ''
      this.getData()
    },

    reset () {
      this.pageNum = 1
      this.getData()
    },

    handleSelectionChange (val) {
      this.value = val
    },

    save () {
      this.$emit('save', this.value)
    },

    close () {
      this.$emit('close')
    }
  }
}
</script>

<style lang='stylus' scoped>
  .transmit-warp
    position fixed
    left 0
    top 0
    width 100%
    height 100%
    background rgba(0, 0, 0, .3)
    z-index 1
    display flex
    align-items center
    justify-content center
    .transmit
      width 50%
      height 70%
      background #ffffff
      border-radius 20px
      padding 20px
      display flex
      flex-direction column
      .table
        flex auto
        overflow hidden
        margin-bottom 20px
      .btn
        text-align center
        margin-top 20px
</style>
